import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { API_BASE_URL, authFetch } from '../../config/api';
import { useAuth } from '../../context/AuthContext';

interface StagingProposal {
  id: number;
  title: string;
  status: string;
  source_type: string | null;
  target_file_path: string | null;
  created_at: string;
}

async function fetchStaging(): Promise<StagingProposal[]> {
  const res = await authFetch(`${API_BASE_URL}/api/knowledge/staging`);
  if (!res.ok) throw new Error(await res.text());
  const json = await res.json();
  return json.proposals || json;
}

export default function PendingKnowledge() {
  const { isAuthenticated } = useAuth();

  const { data: proposals, isLoading, isError } = useQuery(
    ['knowledge-staging-dash'],
    fetchStaging,
    { enabled: isAuthenticated },
  );

  if (!isAuthenticated) return null;

  const pending = proposals?.filter(p => p.status === 'pending') || [];

  return (
    <div className="dash-card">
      <div className="dash-card__header">
        <h3>Pending Knowledge</h3>
        {pending.length > 0 && (
          <span className="dash-card__badge dash-card__badge--warn">{pending.length}</span>
        )}
      </div>
      <div className="dash-card__body dash-card__body--scroll">
        {isLoading && <p className="dash-card__msg">Loading...</p>}
        {isError && <p className="dash-card__msg dash-card__msg--error">Failed to load</p>}
        {!isLoading && !isError && pending.length === 0 && (
          <p className="dash-card__msg">No pending proposals</p>
        )}
        {pending.length > 0 && (
          <ul className="pending-list">
            {pending.slice(0, 6).map(p => (
              <li key={p.id} className="pending-list__item">
                <span className="pending-list__title">{p.title}</span>
                {p.source_type && (
                  <span className="pending-list__source">{p.source_type}</span>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
      {pending.length > 0 && (
        <Link to="/knowledge" className="dash-card__footer-link">
          Review all &rarr;
        </Link>
      )}
    </div>
  );
}
